// Create Code Shipping
export const CREATE_CODE_SHIPPING_REQUEST = 'CREATE_CODE_SHIPPING_REQUEST';
export const CREATE_CODE_SHIPPING_DONE = 'CREATE_CODE_SHIPPING_DONE';
export const CREATE_CODE_SHIPPING_FAILED = 'CREATE_CODE_SHIPPING_FAILED';
export const CREATE_CODE_SHIPPING_RESET = 'CREATE_CODE_SHIPPING_RESET';